var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2 3C10.2 1.895 10.896 1 12 1C13.104 1 13.8 1.895 13.8 3L14 11C14 10.636 14.5 5.34 14.5 5C14.5 4 15.095 3 16.2 3C17.305 3 18 3.895 18 5V12.268C18.083 12.22 18.3 8.422 18.3 8C18.3 7 18.563 6 19.5 6C20.438 6 21 6.895 21 8V14C21 16.1217 20.1571 18.1566 18.6569 19.6569C17.1566 21.1571 15.1217 22 13 22H12.326C10.8404 21.9999 9.38417 21.5862 8.12045 20.8052C6.85672 20.0242 5.83543 18.9067 5.171 17.578L2.329 11.894C1.965 11.166 2.245 10.226 3.049 9.87C3.472 9.683 3.946 9.578 4.392 9.72C5.5 10.073 5.336 10.58 6 11.21V5C6 3.895 6.695 3 7.8 3C8.8 3 9.409 4.315 9.5 5C9.625 5.938 10 10.634 10 10.998L10.2 3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanFill);
export default __webpack_public_path__ + "static/media/pan-fill.30f023b845dd9191d1e0d2d00ad3a2b0.svg";
export { ForwardRef as ReactComponent };